<!--cancel payment/invoice modal-->
<nz-modal [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="850" nzCentered
    [nzVisible]="showCancelTransactionModal"
    [nzTitle]="transactionType == transactoinTypeEnum.Payment? 'Cancel Payment' : 'Edit | Cancel' +  (currentTransactionDetails.transactionsSubType == 1 ? ' Estimate' : ' Invoice')" [nzFooter]="footerTpl"
    (nzOnCancel)="handleCancel(null, null, null,null)">
    <ng-container *nzModalContent>
        <div *ngIf="transactionType == transactoinTypeEnum.Payment">
     <p class="Font-Regular  pb-1"> A request to cancel is subject to review and does not guarantee the transaction can be canceled before
        processing. We will notify you when this action has been completed</p> 
        </div>
        <div *ngIf="transactionType != transactoinTypeEnum.Payment"> <p class="Font-Regular"> A request to {{radioValue == 'A' ? 'edit' : 'cancel'}} an invoice will be reviewed immediately, but does
         not guarantee the transaction can be canceled before being processed. We will notify you when this action
            has been completed.</p>
            <div class="request-box">
            Request: <nz-radio-group [(ngModel)]="radioValue">
                <label nz-radio nzValue="A">Edit</label>
                <label nz-radio nzValue="B">Cancel</label>
            </nz-radio-group>
            </div>
            <br>
            <div *ngIf="radioValue == 'A'">
            <nz-form-item>
                <nz-form-control>
                    <label class="label-text">Contact</label>
                    <input class="input-group" nz-input [(ngModel)]="contact" minlength="2" maxlength="150"
                        placeholder="Enter name and email address" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-control>
                    <label class="label-text">Amount</label>
                    <div class="cl-gray fs-17">Current amount: {{currentTransactionDetails.transactionsAmount ? (currentTransactionDetails.transactionsAmount | currency) : (currentTransactionDetails.amount | currency)}}</div>
                    <input autocomplete="off" class="input-group" nz-input [(ngModel)]="amount"
                        placeholder="Enter new amount" [allowNegativeNumbers]="false" (keypress)="_cS.checkDecimalNumbers($event, amount)" 
                         maxlength="13"  (blur)="formatAmount(amount)" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-control>
                    <label class="label-text">Description</label>
                    <div class="d-flex fs-17"><div class="cl-gray ellipsis-text w-auto" nz-tooltip [nzTooltipTitle]="currentTransactionDetails.description?.length > 70 ? currentTransactionDetails.description : ''" >Current description: {{currentTransactionDetails.description ? currentTransactionDetails.description : '-'}} </div>
                    <span *ngIf="!isDescCopied && currentTransactionDetails.description" class="ml-10 mt-03 cursor cl-theme" nz-icon nzType="copy" (click)="pasteToNewDesc()" nzTheme="outline"></span>
                    <span class="mt-03 cl-theme" nz-icon nzType="check" nzTheme="outline" *ngIf="isDescCopied"></span> 
                    <span *ngIf="this.description" (click)="description = ''" class="ml-10 mt-03 cursor cl-theme" nz-icon nzType="clear" nzTheme="outline"></span></div>
                    <textarea class="input-group" nz-input rows="4" [(ngModel)]="description" minlength="2"
                        maxlength="500" placeholder="Enter new description"></textarea>
                </nz-form-control>
            </nz-form-item>
        </div>
        </div>
        <form nz-form [formGroup]="_fS.cancelPaymentForm">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="address1Error">
                    <label class="label-text required">Reason</label>
                    <textarea class="input-group" nz-input rows="4" formControlName="reason" minlength="2"
                        maxlength="1000" placeholder="Please provide as much details as possible upto 1000 characters"></textarea>
                    <ng-template #address1Error let-control>
                        <ng-container *ngIf="control.hasError('required')">Please enter reason </ng-container>
                        <ng-container *ngIf="control.hasError('minlength')">reason must contain at least 2
                            characters
                        </ng-container>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end">
            <button nz-button nzType="default" (click)="handleCancel(null, null, null)" class="default-btn width-100">
                Close
            </button>
            <button nz-button nzType="primary" (click)="handleOk()"
                class="medium-btn small-btn width-100">
                Send
            </button>
        </div>
    </ng-template>
</nz-modal>

<!--Confirmation sending request-->
<nz-modal [(nzVisible)]="sendConfirmVisible" nzCentered [nzMaskClosable]="false" (nzOnCancel)="handleCancelSend()">
    <div class="confirm-modal">
      <ng-container *nzModalContent class="cc">
        <div class="close-icon center">
          <i nz-icon nzType="question" nzTheme="outline"></i>
        </div>
        <h4 class="confirm-modal-title center">Are You Sure?</h4>
        <p class="confirm-modal-sub-title center">
          You want to {{ transactionType != transactoinTypeEnum.Payment && radioValue == 'A' ? 'edit' : 'cancel' }} the transaction.
        </p>
      </ng-container>
      <div *nzModalFooter class="d-flex justify-content-end">
        <button nz-button nzType="default" (click)="handleCancelSend()" class="default-btn width-100">
          Close
        </button>
        <button nz-button nzType="primary" (click)="(transactionType == transactoinTypeEnum.Investment && radioValue == 'A') ? editTransaction() : cancelTransaction()" class="medium-btn delete-btn width-100"
          [nzLoading]="isLoadingReq">
          Send
        </button>
      </div>
    </div>
  </nz-modal>